import React from 'react';
import styled from 'styled-components';
import { ISubFolderFieldsFragment } from '../../../../../utils/apollo/graphqlSchema';
import { theme } from '../../../../../styles/theme';

interface IProps {
  path: ISubFolderFieldsFragment[];
}

const Container = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: ${theme.colors.secondary800};
`;

const DashboardPagePath = ({ path }: IProps) => (
  <Container>{path.map((sf) => sf.name).join(' > ')}</Container>
);

export default DashboardPagePath;
